import { IconButton } from "@mui/material";
import CustomTooltip from "./CustomTooltip";
import styled from "styled-components";
import GlobalFunctionHelper from '../../Utilities/Helpers/GlobalFunctionHelper';
import { CustomIconButtonInterface } from "../../Models/Common/CustomViewsInterfaces";

const StyledIconButton = styled(IconButton) <{ $isDelete: boolean, $iconColor: any }>`
    .MuiSvgIcon-root {
        color: ${props => props.$iconColor ? props.$iconColor : props.$isDelete ? 'var(--deleteButtonBGColor)' : props.theme.secondaryText};
        font-size: ${props => props.$isDelete ? '1.65rem' : '1.5rem'};
    }
`;
const CustomIconButton = (props: CustomIconButtonInterface) => {
    return <CustomTooltip {...{
        tooltipClass: (props?.id && props.id != "" ? props.id : GlobalFunctionHelper.getRanHex(24)),
        tooltipName: props.toolTipName,
        placement: "top",
        tooltipContent:
            <StyledIconButton className={props?.className ?? ""} $isDelete={props.toolTipName.toLowerCase() == "delete"}
                disabled={props.disabled}
                $iconColor={props.iconColor}
                onClick={(e: any) => {
                    e.stopPropagation();
                    props.onClick(e);
                }}>
                {props.icon}
            </StyledIconButton>,
    }} />
}

export default CustomIconButton;